import "./styles/companyIcons.css";
import CompanyIcon from "../CompanyIcons/companyIcon";

const CompanyIcons = () => {
    return (
        <div className="company-icons">
            <CompanyIcon src="DollarGeneral_logo.png" alt="dollarGeneral" />
            <CompanyIcon src="Walmart_logo.png" alt="walmart" />
            <CompanyIcon src="DollarTree_logo.png" alt="dollarTree" />
            <CompanyIcon src="Target_logo.png" alt="target" />
            <CompanyIcon src="Dollarama_logo.png" alt="dollarama" />
            <CompanyIcon src="HobbyLobby_logo.png" alt="hobbyLobby" />
            <CompanyIcon src="LoBlaws_logo.png" alt="loblaws" />
            <CompanyIcon src="FamilyDollar_logo.png" alt="familyDollar" />
            <CompanyIcon src="Sam_logo.png" alt="samsClub" />
            <CompanyIcon src="Michael_logo.png" alt="michales" />
            <CompanyIcon src="WalmartCan_logo.png" alt="walmartCanada" />
        </div>
    );
};

export default CompanyIcons;
